import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const EmptyLayout = props => {
    const { children } = props;
    return _jsx(_Fragment, { children: children });
};
